import { inject, injectable } from 'inversify'
import type { MessageSendRepeatMonthlyFormScheme, OrdinalDay } from '@/services/domain/messages/types'
import type { SelectFieldConfig } from '@/services/forms/types'
import type {
  FormGroupConfigurationInterface,
  TypedFormBuilderInterface,
} from '@/services/forms/baseForm/typedFormBuilder/types'
import type { Translatable, WeekDaysFull } from '@/services/types'
import { AbstractFormGroupConfiguration } from '@/services/forms/messages/formGroupConfiguration/AbstractFormGroupConfiguration'
import type ComposeScheduledInitFormData from '@/services/domain/compose/ComposeScheduledInitFormData'
import { SERVICE_TYPES } from '@/core/container/types'
import type DateTimeService from '@/services/dateTimeService'

@injectable()
export class MonthlyFormGroupConfiguration
  extends AbstractFormGroupConfiguration
  implements FormGroupConfigurationInterface<MessageSendRepeatMonthlyFormScheme>
{
  constructor(
    @inject(SERVICE_TYPES.TranslateService) protected readonly translateService: Translatable,
    @inject(SERVICE_TYPES.DateTimeService) protected readonly dateTimeService: DateTimeService,
    @inject(SERVICE_TYPES.ComposeScheduledInitFormData)
    protected readonly composeScheduledInitFormData: ComposeScheduledInitFormData,
  ) {
    super(translateService, dateTimeService)
  }

  public configure(builder: TypedFormBuilderInterface<MessageSendRepeatMonthlyFormScheme>): void {
    const messageSendRepeatInitFormData = this.composeScheduledInitFormData.getMessageSendRepeatInitFormData()

    builder
      .property((t) => t.count)
      .control({
        fieldType: 'number',
        value: messageSendRepeatInitFormData.monthly.count,
      })
    builder
      .property((t) => t.repeat)
      .control({
        fieldType: 'radio',
        value: messageSendRepeatInitFormData.monthly.repeat,
      })
    builder
      .property((t) => t.monthDay)
      .control<SelectFieldConfig>({
        fieldType: 'select',
        value: messageSendRepeatInitFormData.monthly.monthDay,
        options: () => this.getSelectMonthDayOptions(),
      })
    builder
      .property((t) => t.firstLastDay)
      .control<SelectFieldConfig<OrdinalDay>>({
        fieldType: 'select',
        value: messageSendRepeatInitFormData.monthly.firstLastDay,
        options: () => this.getSelectOrdinalDaysOptions(),
      })
    builder
      .property((t) => t.weekDay)
      .control<SelectFieldConfig<WeekDaysFull>>({
        fieldType: 'select',
        value: messageSendRepeatInitFormData.monthly.weekDay,
        options: () => this.getSelectWeekDaysOptions(),
      })
  }
}
